import { Business } from "@/config";
import { HttpStatusCode } from "axios";
import { useEffect, useState } from "react";
import { getShop, setShop } from "@/utils/auth";
import { getBusinesseById } from "@/services/ServiceApi";

export function useFetchBusinessSetting() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<Business | null>(null);

    const fetchBusiness = async () => {
        setLoading(true);
        const shop = getShop();
        if (shop) {
            const resBus = await getBusinesseById(shop._id);
            if (resBus.statusCode === HttpStatusCode.Ok) {
                setShop({
                    ...shop,
                    ...resBus.data
                });
                setData(resBus.data);
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchBusiness();
        // eslint-disable-next-line
    }, []);

    return { data, loading, refetch: fetchBusiness };
}
